import { addMessage } from '../redux/infoMessageSlice';
import { AppDispatch } from '../store/store';

export const getUsersWithoutMunicipality = async (
  auth: string,
  dispatch: AppDispatch
) => {
  const { REACT_APP_API_URL } = process.env;
  try {
    const response = await fetch(`${REACT_APP_API_URL}/api/openusers/`, {
      method: 'GET',
      headers: {
        Authorization: auth,
      },
    });
    if (response.ok) {
      return await response.json();
    } else {
      dispatch(
        addMessage({
          message: 'error.failedToFetch',
          error: 'Municipality Not Found',
        })
      );
    }
  } catch (error) {
    dispatch(
      addMessage({
        message: 'error.failedToFetch',
        error: (error as Error).name,
      })
    );
  }
};
